import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrudService {

  constructor(
    private http: HttpClient
  ) { }


  public getData(endpoint: string, param?: string, body?: any) {
    if (param) {
      return this.http.get(`${environment.API_BASE}api/${endpoint}/${param}`);
    }
    if (body) {
      return this.http.get(`${environment.API_BASE}api/${endpoint}`, body);
    }
    return this.http.get(`${environment.API_BASE}api/${endpoint}`);
  }

  public postData(endpoint: string, param?: string, values?: any) {
    if (param) {
      return this.http.post(`${environment.API_BASE}api/${endpoint}/${param}`, values);
    }
    return this.http.post(`${environment.API_BASE}api/${endpoint}`, values);
  }

  public patchData(endpoint: string, params?: any) {
    return this.http.patch(`${environment.API_BASE}api/${endpoint}`, params);
  }

  public putData(endpoint: string, params?: any) {
    return this.http.put(`${environment.API_BASE}api/${endpoint}`, params);
  }

  public deleteData(endpoint: string, param?: string) {
    if (param) {
      return this.http.delete(`${environment.API_BASE}api/${endpoint}/${param}`);
    }
    return this.http.delete(`${environment.API_BASE}api/${endpoint}`);
  }
}
